import { Link } from "react-router-dom";

const articles = [
  {
    slug: "/mulebuy-spreadsheet-guide",
    title: "Mulebuy Spreadsheet Beginner Guide 2026",
    excerpt: "Learn everything you need to know about getting started with the mulebuy spreadsheet system for agent shopping.",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20on%20a%20light%20wood%20desk%20near%20a%20window%20morning%20sunlight%20streaming%20in%20organized%20desk%20with%20sticky%20notes%20and%20a%20ceramic%20coffee%20cup%20professional%20productive%20atmosphere%20editorial%20photography%20warm%20tones&width=600&height=400&seq=art-hub-begin&orientation=landscape",
    tag: "Beginner Guide"
  },
  {
    slug: "/mulebuy-spreadsheet-tools",
    title: "Best Mulebuy Spreadsheet Tools Ranked 2026",
    excerpt: "Compare the top spreadsheet tools and tracking systems for agent shopping in our comprehensive ranking guide.",
    image: "https://readdy.ai/api/search-image?query=Multiple%20browser%20windows%20and%20apps%20displayed%20on%20a%20dual%20monitor%20setup%20showing%20different%20spreadsheet%20interfaces%20and%20analytics%20dashboards%20modern%20tech%20workspace%20with%20mechanical%20keyboard%20warm%20ambient%20desk%20lamp%20lighting%20professional%20comparison%20photography&width=600&height=400&seq=art-hub-tools&orientation=landscape",
    tag: "Reviews"
  },
  {
    slug: "/mulebuy-spreadsheet-comparison",
    title: "Mulebuy Spreadsheet vs Competitor Tools",
    excerpt: "Full comparison of tracking tools and spreadsheet systems for agent shopping — see which one wins.",
    image: "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20different%20laptops%20on%20a%20long%20wooden%20conference%20table%20each%20showing%20different%20spreadsheet%20layouts%20overhead%20view%20clean%20corporate%20photography%20bright%20even%20lighting%20balanced%20composition%20split%20screen%20aesthetic&width=600&height=400&seq=art-hub-compare&orientation=landscape",
    tag: "Comparison"
  },
  {
    slug: "/mulebuy-spreadsheet-tutorial",
    title: "How to Use Mulebuy Spreadsheet Effectively",
    excerpt: "Step-by-step tutorial covering every feature of the mulebuy spreadsheet system to maximize your workflow.",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20spreadsheet%20cells%20visible%20on%20screen%20soft%20focus%20background%20showing%20a%20cozy%20home%20office%20with%20plants%20warm%20natural%20light%20tutorial%20style%20photography%20educational%20atmosphere&width=600&height=400&seq=art-hub-tutorial&orientation=landscape",
    tag: "Tutorial"
  },
  {
    slug: "/mulebuy-spreadsheet-safety",
    title: "Is Mulebuy Spreadsheet Safe to Use?",
    excerpt: "Everything you need to know about data security, privacy, and safety when using mulebuy spreadsheet tools.",
    image: "https://readdy.ai/api/search-image?query=A%20padlock%20icon%20displayed%20prominently%20on%20a%20laptop%20screen%20with%20spreadsheet%20data%20blurred%20in%20the%20background%20modern%20cybersecurity%20concept%20photography%20dark%20moody%20lighting%20with%20a%20blue%20security%20glow%20professional%20trust%20themed%20composition&width=600&height=400&seq=art-hub-safety&orientation=landscape",
    tag: "Safety"
  },
  {
    slug: "/mulebuy-spreadsheet-alternatives",
    title: "Top Alternatives to Mulebuy Spreadsheet",
    excerpt: "Explore the best alternatives to the mulebuy spreadsheet system and see how they stack up against each other.",
    image: "https://readdy.ai/api/search-image?query=A%20collection%20of%20different%20devices%20tablets%20phones%20and%20laptops%20arranged%20in%20a%20circle%20on%20a%20concrete%20floor%20each%20showing%20different%20app%20interfaces%20overhead%20shot%20creative%20technology%20photography%20vibrant%20colorful%20displays%20against%20neutral%20background&width=600&height=400&seq=art-hub-alt&orientation=landscape",
    tag: "Alternatives"
  },
  {
    slug: "/mulebuy-spreadsheet-automation",
    title: "Automation Tips for Mulebuy Spreadsheet",
    excerpt: "Discover powerful automation tricks that save hours every week with your mulebuy spreadsheet tracking workflow.",
    image: "https://readdy.ai/api/search-image?query=Macro%20automation%20workflow%20diagram%20drawn%20on%20a%20whiteboard%20next%20to%20a%20laptop%20running%20spreadsheet%20software%20modern%20office%20setting%20bright%20fluorescent%20lighting%20productivity%20concept%20photography%20clean%20organized%20composition&width=600&height=400&seq=art-hub-auto&orientation=landscape",
    tag: "Tips"
  },
  {
    slug: "/mulebuy-spreadsheet-errors",
    title: "Common Errors in Mulebuy Spreadsheet — Fixed",
    excerpt: "Troubleshooting guide for the most frequent mulebuy spreadsheet issues and how to resolve them quickly.",
    image: "https://readdy.ai/api/search-image?query=A%20laptop%20screen%20showing%20a%20spreadsheet%20with%20a%20warning%20triangle%20symbol%20and%20red%20highlighted%20cells%20softly%20lit%20desk%20setting%20with%20a%20notebook%20and%20pen%20nearby%20problem%20solving%20concept%20photography%20warm%20ambient%20lighting%20solution%20focused%20composition&width=600&height=400&seq=art-hub-errors&orientation=landscape",
    tag: "Troubleshooting"
  },
  {
    slug: "/mulebuy-spreadsheet-business",
    title: "How Businesses Use Mulebuy Spreadsheet",
    excerpt: "Real-world case studies of businesses scaling their operations with the mulebuy spreadsheet tracking system.",
    image: "https://readdy.ai/api/search-image?query=A%20busy%20modern%20open%20plan%20office%20with%20diverse%20team%20members%20collaborating%20around%20a%20large%20monitor%20displaying%20spreadsheet%20analytics%20graphs%20and%20charts%20corporate%20lifestyle%20photography%20bright%20natural%20lighting%20professional%20dynamic%20atmosphere&width=600&height=400&seq=art-hub-biz&orientation=landscape",
    tag: "Business"
  },
  {
    slug: "/mulebuy-spreadsheet-trending",
    title: "Why Mulebuy Spreadsheet Is Trending in 2026",
    excerpt: "The rise of the mulebuy spreadsheet — why thousands of shoppers are switching to structured tracking this year.",
    image: "https://readdy.ai/api/search-image?query=An%20upward%20trending%20arrow%20graph%20displayed%20prominently%20on%20a%20tablet%20screen%20against%20a%20backdrop%20of%20a%20modern%20stylish%20coffee%20shop%20with%20people%20working%20on%20laptops%20lifestyle%20photography%20warm%20ambient%20lighting%20growth%20concept%20energetic%20composition&width=600&height=400&seq=art-hub-trend&orientation=landscape",
    tag: "Trends"
  }
];

export default function ArticleHub() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-bold text-foreground-400 uppercase tracking-wider mb-3">
            SEO Resources & Guides
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-[1.05] tracking-tight">
            Master Your Shopping<span className="block text-primary-500">With Spreadsheet Guides</span>
          </h2>
          <p className="mt-4 text-sm text-foreground-500 max-w-xl">
            Explore our in-depth guides and resources on the{" "}
            <Link to="/" className="text-foreground-800 font-semibold border-b border-foreground-400 hover:border-foreground-800 transition-colors">
              mulebuy spreadsheet hub
            </Link>
            {" "}to learn everything about optimizing your agent shopping workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-full text-[10px] font-bold text-foreground-800 whitespace-nowrap">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Article
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line text-[10px]"></i></span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}